var base = require('base/product/base');

var SELECTOR_PRODUCT_DETAIL = '.product-detail';
var SELECTOR_PRODUCT_ID = '.product-id';
var SELECTOR_QUANTITY_SELECT = '.quantity-select';

var isATCtimerRunnig = false;

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest(SELECTOR_PRODUCT_DETAIL).find(SELECTOR_PRODUCT_ID).text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $el.parents('.product-slider').length) {
        quantitySelected = $el.parents('.product-slider').find(SELECTOR_QUANTITY_SELECT);
    } else if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest(SELECTOR_PRODUCT_DETAIL).find(SELECTOR_QUANTITY_SELECT);
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find(SELECTOR_QUANTITY_SELECT);
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find(SELECTOR_QUANTITY_SELECT);
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else if ($el && $('.quick-view-dialog:visible').length) {
        quantitySelected = $('.quick-view-dialog .quantity-select');
    } else {
        quantitySelected = $(SELECTOR_QUANTITY_SELECT);
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        var isDigiflyer = $('.page').data('action') === 'Page-Digiflyer';
        var $minicartLink = $('.minicart-link');
        var cartUrl = $minicartLink.attr('href');
        var viewCartLabel = $minicartLink.data('view-cart-label');
        var viewCartTarget = isDigiflyer ? '_blank' : '_self';
        var viewCartRel = isDigiflyer ? ' rel="noopener noreferrer"' : '';
        var viewCartLink = ' <a class="text-primary font-weight-semibold" href="' + cartUrl + '" target="' + viewCartTarget + '"' + viewCartRel + '>' + viewCartLabel + '</a>'; // NOSONAR

        $('.add-to-cart-messages').html('').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' // NOSONAR
            + response.message
            + '<br/>'
            + viewCartLink
            + '</div>'
        );

        if(!isATCtimerRunnig) {
            isATCtimerRunnig = true;
            setTimeout(function () {
                $('.add-to-basket-alert').remove();
                isATCtimerRunnig = false;
            }, 5000);
        }
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find(SELECTOR_PRODUCT_ID).text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]') // NOSONAR
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

base.addToCart = function () {
    $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
        var addToCartUrl;
        var pid;
        var pidsObj;
        var setPids;

        $.spinner().start();

        $('body').trigger('product:beforeAddToCart', this);

        if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
            setPids = [];

            $(SELECTOR_PRODUCT_DETAIL).each(function () {
                if (!$(this).hasClass('product-set-detail')) {
                    setPids.push({
                        pid: $(this).find(SELECTOR_PRODUCT_ID).text(),
                        qty: $(this).find(SELECTOR_QUANTITY_SELECT).val(),
                        options: getOptions($(this))
                    });
                }
            });
            pidsObj = JSON.stringify(setPids);
        }

        pid = getPidValue($(this)) || $(this).data('pid');

        var $productContainer = $(this).closest(SELECTOR_PRODUCT_DETAIL);
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find(SELECTOR_PRODUCT_DETAIL);
        }

        addToCartUrl = getAddToCartUrl();

        var form = {
            pid: pid,
            pidsObj: pidsObj,
            childProducts: getChildProducts(),
            quantity: getQuantitySelected($(this))
        };

        if (!$('.bundle-item').length) {
            form.options = getOptions($productContainer);
        }

        $(this).trigger('updateAddToCartFormData', form);
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    miniCartReportingUrl(data.reportingURL);

                    if (window.adobeDataLayer && data.dumbleData && data.dumbleData.productInfo) {
                        window.adobeDataLayer.push({
                            "event": "add_to_cart",
                            "productInfo": data.dumbleData.productInfo
                        });
                    }

                    if (!$('.cart-page').length) {
                        $.spinner().stop();
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
};

module.exports = base;
